import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ALPHABETS } from './alphabets';
import { TranslateService } from '@ngx-translate/core';
import { Language } from '@new-core/types/methodic-materials.types';
import { GameParameterControl } from '@games/core/parameters/directive';
import { Subject } from 'rxjs';

@Component({
  selector: 'ms-alphabet-picker',
  templateUrl: './alphabet-picker.component.html',
  styleUrls: ['./alphabet-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AlphabetPickerComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class AlphabetPickerComponent implements GameParameterControl {
  public get value(): Language {
    return this._value;
  }

  public set value(value: Language) {
    this._value = value;
    this.onChange(value);
    this.blurEmitter.next(void 0);
  }

  constructor(private _translateService: TranslateService) {}

  public readonly ALPHABETS = ALPHABETS;

  private _value: Language = 'ru';

  isDisabled: boolean;

  readonly blurEmitter = new Subject<void>();

  readonly focusEmitter = new Subject<void>();

  onChange: any;

  onTouch: any;

  public readonly languages: Language[] = [
    'ru',
    'en',
    'ua',
    'br',
    'az',
    'am',
    'kg',
    'ro',
    'uz',
    'kz',
    'pl',
    'bg',
  ];

  ngAfterViewInit() {
    if (!this._value) {
      this.value = this._translateService.currentLang as Language;
    }
  }

  writeValue(obj: Language): void {
    this._value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
